import { createAction } from 'redux-actions'
import fetch from 'lib/fetch'
import { getActivityByWorkspaceSlug } from 'selectors'

export const REQUEST_ACTIVITY = 'REQUEST_ACTIVITY'
export const REQUEST_ACTIVITY_ERROR = 'REQUEST_ACTIVITY_ERROR'
export const RECEIVE_ACTIVITY = 'RECEIVE_ACTIVITY'

export const fetchActivity = workspaceSlug => ({
  types: {
    request: REQUEST_ACTIVITY,
    receive: RECEIVE_ACTIVITY,
    failure: REQUEST_ACTIVITY_ERROR
  },
  payload: { workspaceSlug },
  shouldCallAPI: state => {
    const activity = getActivityByWorkspaceSlug(state, workspaceSlug)
    if (!activity) return true
    return !activity.isRequesting
  },
  callAPI: () => fetch(`/api/workspaces/${workspaceSlug}/activity`).then(res => {
    if (!res.ok) {
      const error = new Error('Unable to fetch activity')
      error.code = res.status
      throw error
    }
    return res.json()
  })
})

export const TOGGLE_SHOW_MORE_ACTIVITY = 'TOGGLE_SHOW_MORE_ACTIVITY'
export const toggleShowMoreActivity = createAction(TOGGLE_SHOW_MORE_ACTIVITY)
export const SET_ACTIVITY_FILTER = 'SET_ACTIVITY_FILTER'
export const setActivityFilter = createAction(SET_ACTIVITY_FILTER)
export const SET_ACTIVITY_SEARCH_TERM = 'SET_ACTIVITY_SEARCH_TERM'
export const setActivitySearchTerm = createAction(SET_ACTIVITY_SEARCH_TERM)



// WEBPACK FOOTER //
// ./actions/activity.js